<template>
  <div class="content-wrapper selection-choose-bike">
    <div class="d-flex full-height justify-content-center">
        <div class="center w-100">
            <div class="mt-5 mb-5">
                <div class="uppercase small-text pb-4">SELECT A PRE-CONFIGURED MODEL OR BUILD YOUR </div>
            </div>
            <div class="configurations d-flex justify-content-center">
               <div class="configuration">
                    <img :src="'/storage/' + bike.frame_image" style="width: 80%">
                    <div>
                    <h5>No pre-configuration</h5>
                    <div class="price" style="visibility:hidden">0,00&euro;</div>
                  </div>
                  <button class="btn btn-outline-primary" id="build-from-scratch" v-on:click="configureBike">build your bike from scratch</button>
                </div>
              <div class="configuration" v-if="defaultConfigurations.first!=null">
                <img :src="'/storage/' + defaultConfigurations.first.image">
                <div>
                  <h5>{{bike.name}}<br>1# ({{defaultConfigurations.first.slotName}})</h5>
                  <div class="price">{{defaultConfigurations.first.price | toCurrency }}</div>
                </div>
                <a :href="'/configurator/?load=' + defaultConfigurations.first.id">
                  <button class="btn btn-outline-primary build-preconfigured" >select this model</button>
                </a>
                
              </div>
              <div class="configuration" v-if="defaultConfigurations.second!=null">
                <img :src="'/storage/' + defaultConfigurations.second.image">
                <div>
                  <h5>{{bike.name}}<br>2# ({{defaultConfigurations.second.slotName}})</h5>
                  <div class="price">{{defaultConfigurations.second.price | toCurrency }}</div>
                </div>
                <a :href="'/configurator/?load=' + defaultConfigurations.second.id">
                  <button class="btn btn-outline-primary build-preconfigured">select this model</button>
                </a>
              </div>
              <div class="configuration" v-if="defaultConfigurations.third!=null">
                  <img :src="'/storage/' + defaultConfigurations.third.image">
                  <div>
                    <h5>{{bike.name}}<br>3# ({{defaultConfigurations.third.slotName}})</h5>
                    <div class="price">{{defaultConfigurations.third.price | toCurrency }}</div>
                  </div>
                  <a :href="'/configurator/?load=' + defaultConfigurations.third.id">
                    <button class="btn btn-outline-primary build-preconfigured">select this model</button>
                  </a>
              </div> 
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "selection-choose-bike",
  data() {
    return {}
  },
  props: ["bike", "defaultConfigurations"],
  methods: {
    configureBike: function() {
      this.$emit('configure-bike');
    },
    loadConfiguration: function(id) {
    }
  },
}
</script>

<style lang="scss" scoped>
.selection-choose-bike {
  .configurations {
    margin-top: 140px;
    @media (max-width: 1440px) {
      margin-top: 50px;
    }
    .configuration {
      width: 25%;
      /* display: inline-block; */
      position: relative;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      img {
        width: 100%;
        margin-bottom: 30px;
      }
      .price {
        font-size: 12px;
      }
      button {
        margin-top: 30px;
      }
    }
  }
}
</style>

